<style>
#gradient-div {
  background: #c7fffd;
  /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(white, #d5e0e8);
  /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(white, #d5e0e8);
  /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(white, #d5e0e8);
  /* For Firefox 3.6 to 15 */
  background: linear-gradient(white, #d5e0e8);
  /* Standard syntax */
}

#gradient-div2 {
  background: #c7fffd;
  /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(white, #d5e0e8);
  /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(white, #d5e0e8);
  /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(white, #d5e0e8);
  /* For Firefox 3.6 to 15 */
  background: linear-gradient(white, #d5e0e8);
  /* Standard syntax */
}
</style>
<template>
  <div>
    <div class="content-box">
      <div class="row element-wrapper">
        <div class="col-sm-12">
          <div class="element-box mb-0">
            <div class="row">
              <div class="col-10">
                <h5 class="form-header">Lista de Extensiones Telefónicas {{ new Date().getFullYear() }}</h5>
              </div>
            </div>
            <br>
            <div class="col-12">
              <div class="row">
                <button class="btn glow-on-hover btn-md" style="float: right;  height: 0.8cm;"
                  @click="imprimir()">Imprimir &nbsp;<i class="fas fa-print"></i>
                </button> &nbsp;
                <button v-if="esAdmin" class="btn btn-blue btn-md" style="float: right; height: 0.8cm;" 
                  @click="NuevoRegistro()">Nuevo Registro &nbsp;<i class="fas fa-plus"></i></button>
                </div>
              <div>
                <form class="form-inline justify-content-sm-end">
                  <input class="form-control form-control-sm rounded bright" style="width: 500px;"
                    placeholder="Buscar contacto (e.g. nombre, extensión, teléfono)" type="text" v-model="searchtext"
                    @input="filterData" />
                  <div class="input-group-append">
                    <button class="btn btn-link btn-sm" type="button">
                      <i class="fa fa-search" style="color: blue;"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <br>
            <div>
              <table class="table table-hover table-striped">
                <thead class="font-weight-bold">
                  <tr>
                    <td class="col-2">Extensión</td>
                    <td class="col-6">Descripción / Responsable</td>
                    <td class="col-2">Línea Fija</td>
                    <td class="col-1 text-center">Estado</td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="current in data.results" @click="refreshExtensionActual(current)"
                    v-if="current.estado != '9'">
                    <td> {{ current.extension }}</td>
                    <td> {{ current.responsable_area }}</td>
                    <td> {{ current.linea_fija }}</td>
                    <td class="text-center">
                      <i style="font-size: 8px" :class="{
                        'status-pill green': current.estado == 'A',
                        'status-pill red': current.estado == 'B',
                      }"></i>
                    </td>
                  </tr>
                </tbody>
              </table>
              <br>
              <div v-if="data.results.length === 0" style="color: gray; text-align: center;">
                <p>- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - No existe ningún contacto -
                  - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - </p>
              </div>
            </div>
            <br>
            <PaginationComponent :currentPage="currentPage" :data="data" @pagechanged="onPageChange" />
          </div>
        </div>
      </div>
      <!-- DÉBUT MODAL VER DETALLE DE EXTENSIÓN -->
      <div aria-hidden="true" class="onboarding-modal modal fade animated" id="ModalDetalleExt" role="dialog"
        tabindex="-1">
        <div style="padding-right: 0px; height: 500px;" class="modal-dialog" role="document">
          <div class="modal-content text-center">
            <button aria-label="Close" class="close" @click="hideModal()" type="button">
              <span class="close-label on-hover-text">Cerrar</span>
              <span class="os-icon os-icon-close"></span>
            </button>
            <div class="onboarding-slider-w">
              <div class="onboarding-slide">
                <div id="gradient-div" class="onboarding-content with-gradient">
                  <div class="text-left col-12">
                    <div style="text-align: center;">
                      <i class="fas fa-user" style="font-size: 70px;"></i>
                      &nbsp;
                      <i class="centered" style="font-size: 30px;" :class="{
                        'status-pill green': current.estado == 'A',
                        'status-pill red': current.estado == 'B',
                      }"></i>
                      <br><br>
                      <span style="font-size: 19px; font-weight: bold">{{ current.responsable_area }}</span>
                    </div>
                    <br>
                    <div class="row" style="text-align: center;">
                      <div class="col-6">
                        <button class="btn btn-primary btn-sm btn-block" style="border-radius: 1cm; color: green;"
                          disabled v-if="current.estado == 'A'">
                          Línea Activa <i class="fa fa-phone"></i>
                        </button>
                        <button class="btn btn-secondary btn-sm btn-block" style="border-radius: 1cm;" disabled
                          v-if="current.estado == 'B'">
                          Sin Servicio <i class="fas fa-phone-slash"></i>
                        </button>
                      </div>
                      <div class="col-6">
                        <button class="btn btn-dark btn-sm btn-block" style="border-radius: 1cm;" @click="editarLinea()" :disabled="!esAdmin">
                          Editar <i class="fas fa-edit"></i>
                        </button>
                      </div>
                    </div>
                    <hr><br>
                    <div class="row" style="text-align: center;">
                      <div class="col-12" v-if="current.extension">
                        <div class="col-6" style="text-align: left;">
                          <label><b>Extensión #</b></label>
                        </div>
                        <div class="col-12"
                          style="text-align: left; border-color: gray; border:1px solid lightgray; border-radius: 0.2cm; background-color: white;">
                          <span style="font-size: 17px; font-weight: bold" class="todo-content-header">
                            <div style="text-align: left;">
                              <span>{{ current.extension }}</span>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                    <br>
                    <div class="row" style="text-align: center;">
                      <div class="col-12" v-if="current.linea_fija">
                        <div class="col-6" style="text-align: left;">
                          <label><b>Línea Fija</b></label>
                        </div>
                        <div class="col-12"
                          style="text-align: left; border-color: gray; border:1px solid lightgray; border-radius: 0.2cm; background-color: white;">
                          <span style="font-size: 17px; font-weight: bold" class="todo-content-header">
                            <div style="text-align: left;">
                              <span>{{ current.linea_fija }}</span>
                            </div>
                          </span>
                        </div>
                      </div>
                    </div>
                    <br><br>
                    <div v-if="current.estado == 'B'">
                      <button class="btn btn-sm btn-danger">
                        <i class="fa fa-exclamation-triangle"></i>
                        &nbsp;
                        <span>Extensión telefónica en Mantenimiento / Reparación</span>
                      </button>
                    </div>
                    <div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- FIN MODAL VER DETALLE DE EXTENSIÓN-->

      <!-- DÉBUT MODAL EDICIÓN DE EXTENSIÓN -->
      <div aria-hidden="true" class="onboarding-modal modal fade animated" id="ModalEditModal" role="dialog"
        tabindex="-1">
        <div style="padding-right: 0px; height: 500px;" class="modal-dialog" role="document">
          <div class="modal-content text-center">
            <div class="onboarding-slider-w">
              <div class="onboarding-slide">
                <button aria-label="Close" class="close" @click="hideModalEdicion()" type="button">
                  <span class="close-label">Cancelar</span>
                  <span class="os-icon os-icon-close"></span>
                </button>
                <div id="gradient-div2" class="onboarding-content with-gradient">
                  <div class="text-left col-12">
                    <div style="text-align: center;">
                      <i class="fas fa-user" style="font-size: 70px;"></i>
                      <br><br>
                    </div>
                    <br>
                    <div class="row">
                      <div class="col-4"></div>
                      <div style="float: right;" class="col-8">
                        <label v-if="current.estado == 'A'"> Línea Activa</label>&nbsp;
                        <label v-if="current.estado == 'B'"> Línea Inactiva</label>&nbsp;
                        <i class="centered" style="font-size: 30px;" :class="{
                          'status-pill green': current.estado == 'A',
                          'status-pill red': current.estado == 'B',
                        }"></i>
                        &nbsp;
                        <button class="btn btn-sm btn-dark" title="Cambiar Estado" @click="cambiarEstado" :disabled="!esAdmin">
                          <i class="fas fa-exchange-alt"></i>
                        </button>
                      </div>
                    </div>
                    <br>
                    <div class="row" style="text-align: center;">
                      <div class="col-12">
                        <div class="col-6" style="text-align: left;">
                          <label>Responsable / Área</label>
                        </div>
                        <div class="col-12" style="text-align: left;">
                          <span style="font-size: 17px; font-weight: bold" class="todo-content-header">
                            <input class="form-control" v-model="current.responsable_area" type="text" />
                          </span>
                        </div>
                      </div>
                      <hr>
                      <div class="col-12">
                        <div class="col-6" style="text-align: left;">
                          <label>Extensión</label>
                        </div>
                        <div class="col-12" style="text-align: left;">
                          <span style="font-size: 17px; font-weight: bold" class="todo-content-header">
                            <input class="form-control" v-model="current.extension" type="number" />
                          </span>
                        </div>
                      </div>
                      <hr>
                      <div class="col-12">
                        <div class="col-6" style="text-align: left;">
                          <label>Línea Fija</label>
                        </div>
                        <div class="col-12" style="text-align: left;">
                          <span style="font-size: 17px; font-weight: bold" class="todo-content-header">
                            <input class="form-control" v-model="current.linea_fija" type="number" min="8" max="12" />
                          </span>
                        </div>
                      </div>
                      <br>
                    </div>
                    <br><br>
                    <div class="row">
                      <div class="col-6">
                        <button class="btn btn-primary btn-sm btn-block" style="border-radius: 1cm;" @click="guardar()">
                          Guardar Cambios&nbsp;<i class="fa fa-check"></i>
                        </button>
                      </div>
                      <div class="col-6">
                        <button class="btn btn-danger btn-sm btn-block" style="border-radius: 1cm;" @click="de_baja()">
                          Eliminar Contacto &nbsp;<i class="fas fa-trash-alt"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- FIN MODAL EDICIÓN DE EXTENSIÓN-->
    </div>
  </div>
</template>
<script>
import Notifications from "@/notifications/notifications";
import ExtensionesTelefonicasService from '../../services/catalogos/ExtensionesTelefonicasService';
import DynamicService from "@/services/commons/DynamicService";
import PaginationComponent from "@/components/utils/PaginationComponent";

export default {
  components: {
    ExtensionesTelefonicasService,
    PaginationComponent,
  },
  data() {
    return {
      pageCount: 0,
      itemsPerPage: 50,
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filterActivo: 1,
      data: {
        results: []
      },
      current: [],
    };
  },

  mounted() {
    this.refreshData();
    if (this.$route.params.id) {
      this.refreshExtensionActual(this.$route.params.id);
    }
  },
  computed:{
    esAdmin(){
      try{
        const grupos = JSON.parse(localStorage.getItem('grupos') || '[]');
      return grupos.some(g => g.nombre ==='Admin');
      }catch(e){
        return false;
      } 
    }
  },

  methods: {
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({
        page: this.currentPage,
        "filter[search]": this.searchtext,
      });
    },
    guardar(e) {
      let self = this;
      if (!self.current.id) {
        ExtensionesTelefonicasService.save(self.current)
          .then((response) => {
            Notifications.alert.success("¡Hecho!", "Extensión creada correctamente.");
            $("#ModalEditModal").modal("hide");
            self.refreshData();
          })
          .catch((error) => {
            let msg = "Error al registrar extensión";
            if (error.response && error.response.data){
              if (error.response.data.extension){
                msg = error.response.data.extension[0];
              }
              else if (error.response.data.non_field_errors){
                msg = error.response.data.non_field_errors[0];
              }
            else if (typeof error.response.data.detail ==="string"){
              msg = error.response.data.detailM
              }
            }
            Notifications.alert.error("Error", msg);
          });
      } else {
        // Si hay id, Se hace la actualización 
        ExtensionesTelefonicasService.update(self.current.id, self.current)
          .then((response) => {
            Notifications.alert.success("¡Hecho!", "Extensión actualizada correctamente.");
            $("#ModalEditModal").modal("hide");
            self.refreshData();
          })
          .catch((error) => {
            let msg = "Error al registrar extensión";
            if (error.response && error.response.data){
              if (error.response.data.extension){
                msg = error.response.data.extension[0];
              }
              else if (error.response.data.non_field_errors){
                msg = error.response.data.non_field_errors[0];
              }
            else if (typeof error.response.data.detail ==="string"){
              msg = error.response.data.detailM
              }
            }
            Notifications.alert.error("Error", msg);
          });
      }
    },
    showModal() {
      let self = this;
      $("#ModalDetalleExt").modal("show");
      $("#ModalDetalleExt.show-on-load").modal("show");
    },
    hideModal() {
      let self = this;
      $("#ModalDetalleExt").modal("hide");
    },
    hideModalEdicion() {
      $("#ModalEditModal").modal("hide");
      $("#ModalDetalleExt").modal("show");
    },
    refreshData(params) {
      let self = this;
      if (params && params["filter[search]"]) {
        params["filter[search]"] = this.searchtext;
      }

      ExtensionesTelefonicasService.fetch(params).then((res) => {
        self.data = res.data;
      });
    },
    refreshExtensiones() {
      let self = this;
      ExtensionesTelefonicasService.fetch("extension", "responsable_area", {
        extension: this.current.extension,
        responsable_area: this.current.responsable_area,
      }).then((response) => {
        self.showModal();
        self.extension = response.data.results;
      });
    },
    refreshExtensionActual(current) {
      let self = this;
      ExtensionesTelefonicasService.getById(current.id).then((response) => {
        self.current = response.data;
      });
      this.showModal()
    },
    editarLinea() {
      let self = this;
      $("#ModalDetalleExt").modal("hide");
      $("#ModalEditModal").modal("show");
    },
    de_baja() {
      let self = this;
      Notifications.alert.confirm(
        "Eliminar Contacto",
        "¿Desea eliminar el registro?",
        "Si, Anular",
        function () {
          DynamicService.postAction("cat", "extensiones-telefonicas", self.current.id, "anular")
            .then((response) => {
              $("#ModalEditModal").modal("hide");
              Notifications.alert.success("¡Hecho!", "Se eliminó la extensión.");
              self.refreshData()
            })
            .catch((error) => {
              console.log("Error inesperado")
              Notifications.alert.error("Error", error.response.data.detail);
            });
        }
      )
    },
    NuevoRegistro() {
      // Limpia el objeto current para un nuevo registro
      this.current = {
        extension: '',
        responsable_area: '',
        linea_fija: '',
        estado: 'A' // o el valor por defecto que uses
  };
  // Abre el modal de edición
  $("#ModalEditModal").modal("show");
    },
    filterData() {
      this.refreshData({
        page: 1,
        "filter[search]": this.searchtext,
      });
    },

    clearFilterData() {
      this.searchtext = "";
      this.refreshData({
        page: 1,
        "filter[search]": "",
      });
    },
    imprimir() {
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=catalogos/extensiones_telefonicas.jrxml`
      );
    },
    cambiarEstado() {
      if (!this.esAdmin) {
        Notifications.alert.error("Acceso denegado", "Solo los administradores pueden cambiar el estado.");
        return;
      }
      // Cambia el estado entre 'A' y 'B'
      const nuevoEstado = this.current.estado === 'A' ? 'B' : 'A';
      const payload = { ...this.current, estado: nuevoEstado };
      ExtensionesTelefonicasService.update(this.current.id, payload)
        .then(() => {
          this.current.estado = nuevoEstado;
          Notifications.alert.success("¡Hecho!", `Estado cambiado a ${nuevoEstado === 'A' ? 'Activo' : 'Mantenimiento'}`);
          this.refreshData();
        })
        .catch((error) => {
          let msg = "Error al cambiar el estado";
          if (error.response && error.response.data) {
            if (error.response.data.extension) {
              msg = error.response.data.extension[0];
            } else if (error.response.data.non_field_errors) {
              msg = error.response.data.non_field_errors[0];
            } else if (typeof error.response.data.detail === "string") {
              msg = error.response.data.detail;
            }
          }
          Notifications.alert.error("Error", msg);
        });
    }
  }
}
</script>
